import React, { useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { FaSave } from 'react-icons/fa'
import * as xlsx from 'xlsx'
import TransaksiService from '../../../../../services/transaksi/TransaksiService'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalUploadProduksi = ({ showUploadProduksi, handleCloseUploadProduksi, reloadList }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])

    const columns = [
        {
            name: 'NOMOR_AJU',
            cell: row => row['NOMOR_AJU'],
            grow: 0.6
        },
        {
            name: 'SERI_PROD',
            cell: row => row['SERI_PROD'],
            grow: 0.5
        },
        {
            name: 'KODE_PRODUKSI',
            cell: row => row['KODE_PRODUKSI']
        },
        {
            name: 'TGL_PRODUKSI',
            cell: row => row['TGL_PRODUKSI']
        }
    ]

    const handleClickClose = () => {
        setJsonData('')
        handleCloseUploadProduksi()
        reloadList(1)
    }

    const [jsonData, setJsonData] = useState(null)

    const handleUploadFile = (e) => {
        e.preventDefault()
        if (e.target.files) {
            const reader = new FileReader()
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result)
                const workbook = xlsx.read(data, { type: 'array' })
                const sheetsData = {}

                workbook.SheetNames.forEach((sheetname) => {
                    const worksheet = workbook.Sheets[sheetname]
                    const sheetData = xlsx.utils.sheet_to_json(worksheet, { header: 0, blankrows: true })

                    const filteredData = sheetData.filter((row) => {
                        return Object.values(row).some(value => value !== null && value !== undefined && value !== '')
                    })
                    sheetsData[sheetname] = filteredData
                })
                // console.log(sheetsData)
                setJsonData(sheetsData)
            }
            reader.readAsArrayBuffer(e.target.files[0])
        }
    }

    const [loading, setLoading] = useState(false)
    const [showConfirmUpload, setShowConfirmUpload] = useState(false)
    const handleCloseConfirmUpload = () => setShowConfirmUpload(false)
    const handleClickUpload = () => setShowConfirmUpload(true)

    const [showUploadSuccess, setShowUploadSuccess] = useState(false)
    const [showUploadFailed, setShowUploadFailed] = useState(false)

    const handleUpload = () => {
        setLoading(true)
        try {
            if(jsonData.PRODUKSI.length > 0){
                jsonData.PRODUKSI.map( async (mutuProd) => {
                    let jsonProd = {
                        trPpkMutuProdPK : {
                            nomorAju : mutuProd["NOMOR_AJU"],
                            mutuProdSeri: mutuProd["SERI_PROD"]
                        },
                        mutuProdNo: mutuProd["KODE_PRODUKSI"],
                        mutuProdTgl: mutuProd["TGL_PRODUKSI"]
                    }
                    await transaksiService.addPpmMutuProd(jsonProd)
                })
                setShowConfirmUpload(false)
                setShowUploadSuccess(true)
            }
        } catch (error) {
            setShowConfirmUpload(false)
            setShowUploadFailed(true)
        }
        setLoading(false)
    }

    const handleCloseUploadSuccess = () => {
        setShowUploadSuccess(false)
        setJsonData('')
        handleCloseUploadProduksi()
        reloadList(1)
    }

    const handleCloseUploadFailed = () => {
        setShowUploadFailed(false)        
    }

    return (
        <>
            <Modal
                show={showUploadProduksi}
                onHide={handleCloseUploadProduksi}
                size='lg'
                centered
                backdrop='static'
                scrollable
            >
                <Modal.Header><Modal.Title><h6>Upload Data Produksi</h6></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Upload File <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="file" placeholder='Upload File Excel Template Produksi'
                                            className="form-control-sm"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            onChange={e => handleUploadFile(e)}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    {
                        jsonData && (
                            <div>
                                {/* <pre>{JSON.stringify(jsonData, null, 2)}</pre> */}
                                <div className='row'>
                                    <h6>Preview</h6>
                                </div>
                                <div className='row'>
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': 'rgba(255, 251, 1, 0.93)', 'color': 'black' } } }}
                                        columns={columns}
                                        data={jsonData.PRODUKSI}
                                        pagination
                                        highlightOnHover
                                    />
                                </div>
                            </div>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleClickUpload()} ><FaSave /> Upload</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmUpload &&
                <SweetAlert
                    title="Upload Data Produksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Upload...
                            </>
                        ) : (
                            "Upload"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleUpload}
                    onCancel={handleCloseConfirmUpload}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loading}
                >
                    {loading && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Upload data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showUploadSuccess &&
                <SweetAlert
                    success
                    title="Upload Data Produksi Berhasil"
                    onConfirm={handleCloseUploadSuccess}
                    btnSize="sm"
                />
            }
            {
                showUploadFailed &&
                <SweetAlert
                    danger
                    title="Upload Data Produksi Gagal"
                    onConfirm={handleCloseUploadFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalUploadProduksi